import { CancelOutlinedIcon as CloseIcon } from '@botco/library/icons';
import ActionIcon from '~/assets/icons/card/action.svg?react';
import APIIcon from '~/assets/icons/card/api.svg?react';
import AttributeIcon from '~/assets/icons/card/attribute.svg?react';
import CarouselIcon from '~/assets/icons/card/carousel.svg?react';
import DelayIcon from '~/assets/icons/card/delay.svg?react';
import DeviceMobileIcon from '~/assets/icons/card/device_mobile.svg?react';
import FallbackIcon from '~/assets/icons/card/fallback.svg?react';
import FormAIIcon from '~/assets/icons/card/form_ai.svg?react';
import GotoIcon from '~/assets/icons/card/go_to.svg?react';
import GoalIcon from '~/assets/icons/card/goal.svg?react';
import HandOverIcon from '~/assets/icons/card/hand_over.svg?react';
import ImageIcon from '~/assets/icons/card/image.svg?react';
import ImageDataExtractIcon from '~/assets/icons/card/image_extract.svg?react';
import ImageUploadIcon from '~/assets/icons/card/image_upload.svg?react';
import InstaStackIcon from '~/assets/icons/card/instastack.svg?react';
import IntentAIIcon from '~/assets/icons/card/intent_ai.svg?react';
import QuickReplyIcon from '~/assets/icons/card/quick_reply.svg?react';
import ResetFormAIIcon from '~/assets/icons/card/reset_form_ai.svg?react';
import SetAIIcon from '~/assets/icons/card/set_ai.svg?react';
import ShieldCheckIcon from '~/assets/icons/card/shield_check.svg?react';
import TextIcon from '~/assets/icons/card/text.svg?react';
import UserPlusIcon from '~/assets/icons/card/user_plus.svg?react';
import VideoIcon from '~/assets/icons/card/video.svg?react';

export const DEFAULT_LOGO =
  'https://s3.us-west-2.amazonaws.com/botcontent.botco.ai/DEFAULT-1/deploy_webBotIcon_1566112836178.png';

export const CardTypes = {
  TEXT: 1,
  DELAY: 2,
  ATTRIBUTE: 3,
  CAROUSEL: 7,
  API: 8,
  IMAGE: 9,
  VIDEO: 10,
  GOTO: 12,
  HANDOVER: 13,
  QUICK_REPLY: 14,
  DATA_SUBMIT: 15,
  SMS: 16,
  GOAL: 17,
  INSTA_STACK_API: 18,
  SMS_VALIDATION: 19,
  SET_AI: 20,
  FALLBACK: 21,
  INTENT_AI: 22,
  FORM_AI: 23,
  IMAGE_UPLOAD: 24,
  IMAGE_DATA_EXTRACT: 25,
  CLOSE_CHATBOT: 26,
  RESET_FORM_AI: 27,
  ACTION_CARD: 999,
} as const;

export type CardTypesValues = EnumValueType<typeof CardTypes>;

export const CardTypeImage = {
  [CardTypes.TEXT]: TextIcon,
  [CardTypes.DELAY]: DelayIcon,
  [CardTypes.ATTRIBUTE]: AttributeIcon,
  [CardTypes.CAROUSEL]: CarouselIcon,
  [CardTypes.API]: APIIcon,
  [CardTypes.IMAGE]: ImageIcon,
  [CardTypes.VIDEO]: VideoIcon,
  [CardTypes.GOTO]: GotoIcon,
  [CardTypes.HANDOVER]: HandOverIcon,
  [CardTypes.QUICK_REPLY]: QuickReplyIcon,
  [CardTypes.DATA_SUBMIT]: UserPlusIcon,
  [CardTypes.SMS]: DeviceMobileIcon,
  [CardTypes.GOAL]: GoalIcon,
  [CardTypes.INSTA_STACK_API]: InstaStackIcon,
  [CardTypes.SMS_VALIDATION]: ShieldCheckIcon,
  [CardTypes.SET_AI]: SetAIIcon,
  [CardTypes.FALLBACK]: FallbackIcon,
  [CardTypes.INTENT_AI]: IntentAIIcon,
  [CardTypes.FORM_AI]: FormAIIcon,
  [CardTypes.IMAGE_UPLOAD]: ImageUploadIcon,
  [CardTypes.IMAGE_DATA_EXTRACT]: ImageDataExtractIcon,
  [CardTypes.CLOSE_CHATBOT]: CloseIcon,
  [CardTypes.RESET_FORM_AI]: ResetFormAIIcon,
  [CardTypes.ACTION_CARD]: ActionIcon,
} satisfies Record<CardTypesValues, React.ElementType>;
